import React, { Fragment } from "react";
import { useEquipmentV2Selector } from "../../../redux/store";
import type { CommonFinanceInfoType, PriceType } from "../../../../../../common-deprecated/types/CommonTypes";
import { CommonMonthlyPriceLabelKey } from "../../../../../../common-deprecated/priceUtils";
import { formatMonthlyFinancePrice } from "../../../../../shared-logic/utils/priceUtils";
import { getMonthlyPriceSelector } from "../../../../../../common-deprecated/utils";

type MonthlyPriceType = {
    price: PriceType;
    priceFormat: string;
    financeItemId: string;
    financeInfo: CommonFinanceInfoType;
};

const MonthlyPrice = (props: MonthlyPriceType): JSX.Element | null => {
    const { price, priceFormat, financeInfo, financeItemId } = props;

    // If a financeItemId item id is supplied retrieve the monthly rate for that item from the store.
    const monthly: number = useEquipmentV2Selector(getMonthlyPriceSelector(financeItemId, price.monthly));
    const commonSettings = useEquipmentV2Selector((state) => state.commonSettings);

    const renderedPrice = { ...price, monthly };

    if (renderedPrice.monthly <= 0) return null;

    const monthlyRateItems = formatMonthlyFinancePrice(
        renderedPrice,
        financeInfo,
        commonSettings,
        priceFormat,
        renderedPrice.monthly,
    );

    return (
        <div>
            {monthlyRateItems.labels.map((item) => (
                <Fragment key={item.key}>
                    {monthlyRateItems.hasPromotion && item.key === CommonMonthlyPriceLabelKey.PromoPrice ? (
                        <span dangerouslySetInnerHTML={{ __html: item.value }} />
                    ) : (
                        <span dangerouslySetInnerHTML={{ __html: item.value }} />
                    )}
                    <br />
                </Fragment>
            ))}
        </div>
    );
};

export default MonthlyPrice;
